import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u642891214/domains/hobbyverde.com.br/hbuilds/source/repository/src/app/landing-page/components/LandingPageInteractive.jsx");
